import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bg-back-drop',
  // templateUrl: 'xxx',
  templateUrl: './bg-back-drop.component.html',
  styleUrls: ['./bg-back-drop.component.scss']
})
export class BgBackDropComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
